import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-e-boutique',
  templateUrl: './e-boutique.component.html',
  styleUrls: ['./e-boutique.component.scss']
})
export class EBoutiqueComponent implements OnInit {

  constructor(private commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
  }
  
  goTo() {
    if (this.commonService.user) {
      if (this.commonService.user.role === 'VENDEUR_VALIDEE') {
        this.router.navigate(['/compte']);
      } else {
        this.router.navigate(['/devenir-vendeur']);
      }
    } else {
      this.router.navigate(['/login-devenir-vendeur']);
    }
  }
}
